import React, { PropsWithChildren, ReactNode } from "react";

import {
  AppBar,
  Dialog,
  DialogContent,
  DialogActions,
  IconButton,
  Toolbar,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import useDialogWithActionsStyle from "./dialog_with_actions.style";

export interface DialogWithActionsProps extends PropsWithChildren<{}> {
  open: boolean;
  setOpen: (arg: boolean) => void;
  fullScreen: boolean;
  title: string;
  actions?: ReactNode[];
  fullWidth?: boolean;
}

export function DialogWithActions(props: DialogWithActionsProps) {
  const { children, open, setOpen, fullWidth, fullScreen, title, actions } =
    props;
  const classes = useDialogWithActionsStyle();

  const handleClose = () => setOpen(false);

  return (
    <Dialog
      className={fullScreen ? classes.root : undefined}
      fullScreen={fullScreen}
      open={open}
      fullWidth={fullWidth}
    >
      <AppBar className={classes.appBar}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            {title}
          </Typography>
        </Toolbar>
      </AppBar>
      <DialogContent>{children}</DialogContent>
      {/*
      <Container>
        {children}
      </Container>
      */}
      {actions && <DialogActions>{actions}</DialogActions>}
    </Dialog>
  );
}
